type Props = {
    text: string;
    url: string;
    tooltip?: string;
    is_active: boolean;
};

const SimpleLink = (props: Props) => {
    if (props.is_active) {
        const className = `active`;
        return (
            <a className={className} href={props.url} title={props.tooltip}>
                {props.text}
            </a>
        );
    }

    return (
        <span className="text-muted" title={props.tooltip}>
            {props.text}
        </span>
    );
};

export default SimpleLink;
